import { LAYOUTS, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, TextAlignTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { getAppHeader, RegexConfig } from "../../configs/config";
import { ACTION } from "./types";
import { getOTP, goToPrivacy, onChangeDimension, onChangeInput, toggleCTA } from "./actions";
import sharedPropsService, { BUILD_TYPE, getBuildType } from "../../SharedPropsService";
import { getParametersFromURL, isMobile } from "../../configs/utils";
import { api, config, StoreKey } from "../../configs/api";
import { Platform } from "react-native";
import { goToPrivacyAction, goToTermAction, mobileNumberProceed } from "../../features/login/phone_number/actions";
import { PLATFORM_CODE, QUERY_PARAMS } from "../../configs/constants";
import SharedPropsService from "../../SharedPropsService";
import { getParameters, getPlatformName } from "../../configs/uri-config-utils";
// const _isMobile = isMobile();
export const template = async (phone, pan, context, termsLink, privacyLink, _isMobile, isFromPhonepe) => ({
    layout: {
        id: ROUTE.CHECK_LIMIT_MFC_INIT,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'CheckLimitMFCInitParentRootStack', type: WIDGET.STACK },
        ],
    },
    datastore: {
        CheckLimitMFCInitParentRootStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'CheckLimitMFCInitRootStack', type: WIDGET.STACK },
            ]
        },
        CheckLimitMFCInitRootStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: _isMobile ? SizeTypeTokens.MD : SizeTypeTokens.XXXL,
                bottom: _isMobile ? SizeTypeTokens.MD : SizeTypeTokens.MD
            },
            maxWidth: 412,
            widgetItems: isFromPhonepe ? [
                { id: 'CheckLimitMFCInitStack0', type: WIDGET.STACK },
                { id: 'CheckLimitMFCInitStack1', type: WIDGET.STACK },
                { id: 'CheckLimitMFCInitRootStackSpace0', type: WIDGET.SPACE },
                { id: 'phoneInputStack', type: WIDGET.STACK },
                { id: 'mobileNumberSpaceStack', type: WIDGET.STACK },
                { id: 'proceedAfterMobileNumberStack', type: WIDGET.STACK },
                { id: 'panInputStack', type: WIDGET.STACK },
                { id: 'CheckLimitMFCInitStack2', type: WIDGET.STACK },
                { id: 'checkLimitPanSpaceStack', type: WIDGET.STACK },
                { id: 'continueButtonStack', type: WIDGET.STACK },
                { id: 'CheckLimitMFCInitRootStackSpace4', type: WIDGET.SPACE },
                { id: 'MfcentralStack', type: WIDGET.STACK },
                { id: 'termsAndConditionsSpace', type: WIDGET.SPACE },
                { id: 'CheckLimitMFCInitRootStackTermStack', type: WIDGET.STACK },
                { id: 'CheckLimitMFCInitRootStackSpace5', type: WIDGET.SPACE }
            ] :
                [
                    { id: 'CheckLimitMFCInitStack0', type: WIDGET.STACK },
                    { id: 'CheckLimitMFCInitStack1', type: WIDGET.STACK },
                    { id: 'CheckLimitMFCInitRootStackSpace0', type: WIDGET.SPACE },
                    { id: 'PhoneInput', type: WIDGET.INPUT },
                    { id: 'CheckLimitMFCInitRootStackSpace1', type: WIDGET.SPACE },
                    { id: 'PanInput', type: WIDGET.INPUT },
                    { id: 'CheckLimitMFCInitStack2', type: WIDGET.STACK },
                    { id: 'CheckLimitMFCInitRootStackSpace2', type: WIDGET.SPACE },
                    { id: 'CheckLimitMFCInitRootStackSpace3', type: WIDGET.SPACE },
                    { id: 'continue', type: WIDGET.BUTTON },
                    { id: 'CheckLimitMFCInitRootStackSpace4', type: WIDGET.SPACE },
                    { id: 'CheckLimitMFCInitRootStackTermStack', type: WIDGET.STACK },
                    { id: 'CheckLimitMFCInitRootStackSpace4', type: WIDGET.SPACE },
                    { id: 'MfcentralStack', type: WIDGET.STACK },
                    { id: 'CheckLimitMFCInitRootStackSpace5', type: WIDGET.SPACE },
                ],
            dimensionAction: {
                type: ACTION.ON_CHANGE_DIMENSION,
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
                payload: {}
            }
        },
        CheckLimitMFCInitRootStackTermStack: {
            width: StackWidth.MATCH_PARENT,
            justifyContent: 'center',
            alignItems: 'center',
            widgetItems: [
                context !== 'PARTNER' ? {
                    id: "tc_text",
                    type: WIDGET.TERMS_TEXT,
                } : {},
            ]
        },
        tc_text: {
            html: Platform.OS !== "web" ? ` <p style='color:#667085;font-size:10px;font-weight: 400;line-height: 16px;'>
      By proceeding, I accept <a style="text-decoration:none"  href = ${termsLink}><span style='color:#1434CB;'>T&Cs, </a> <a style="text-decoration:none" href = ${privacyLink}><span style='color:#1434CB;'>Privacy Policy</a> and Authorize to obtain</br>my KYC & bureau information.
      </p>` :
                ` <p style='color:#667085;font-size:10px;font-weight: 400;line-height: 16px;text-align: center'>
      By proceeding, I accept <a style="text-decoration:none"  href = ${termsLink}><span style='color:#1434CB;'>T&Cs, </a> <a style="text-decoration:none" href = ${privacyLink}><span style='color:#1434CB;'>Privacy Policy</a> and Authorize to obtain my KYC & bureau information.
      </p>`,
            privacyAction: {
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
                type: ACTION.PRIVACY_POLICY,
                payload: {}
            },
            termsAction: {
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
                type: ACTION.T_AND_C,
                payload: {}
            }
        },
        CheckLimitMFCInitStack0: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: _isMobile ?
                StackJustifyContent.flexStart :
                StackJustifyContent.center,
            widgetItems: [
                { id: 'CheckLimitMFCInitRootStackT1', type: WIDGET.TEXT },
            ]
        },
        CheckLimitMFCInitRootStackTandC: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                {
                    id: "radio",
                    type: WIDGET.RADIO
                },
                {
                    id: "CheckLimitMFCInitRootStackTandCSpace0",
                    type: WIDGET.SPACE
                },
                {
                    id: "tc_text",
                    type: WIDGET.TEXT,
                },
            ]
        },
        assetSearch: {
            type: InputTypeToken.SEARCH
        },
        radio: {
            color: ColorTokens.Primary_100,
            isChecked: true,
            size: IconSizeTokens.MD,
            actionChecked: {
                type: ACTION.CHANGE_INPUT,
                payload: {
                    value: true, widgetId: "radio"
                },
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
            },
            actionUnChecked: {
                type: ACTION.CHANGE_INPUT,
                payload: {
                    value: false,
                    widgetId: "radio"
                },
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
            },
        },
        MfcentralStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'MfcentralStackIcon1', type: WIDGET.ICON },
                { id: 'MfcentralStackSpace0', type: WIDGET.SPACE },
                { id: 'MfcentralStackT1', type: WIDGET.TEXT }
            ]
        },
        MfcentralStackIcon1: {
            name: IconTokens.VerifiedIcon1,
            size: IconSizeTokens.SM
        },
        MfcentralStackT1: {
            label: 'Powered by MFCentral',
            fontSize: _isMobile ? FontSizeTokens.XXS : FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
        },
        continueButtonStack: {
            type: StackType.column,
            hide: true,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: "continue", type: WIDGET.BUTTON }
            ]
        },
        continue: {
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            label: "Check eligibility for FREE",
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.CHECK_LIMIT,
                payload: {
                    value: "",
                    widgetId: "continue",
                    isResend: false,
                },
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
            },
        },
        proceedAfterMobileNumberStack: {
            type: StackType.column,
            hide: false,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: "proceedAfterMobileNumber", type: WIDGET.BUTTON }
            ]
        },
        mobileNumberSpaceStack: {
            type: StackType.column,
            hide: false,
            widgetItems: [
                { id: "CheckLimitMFCInitRootStackSpace1", type: WIDGET.SPACE }
            ]
        },
        proceedAfterMobileNumber: {
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            label: "Proceed",
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.MOBILE_NUMBER_PROCEED,
                payload: {
                    value: "",
                    isResend: false,
                },
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
            },
        },
        checkLimitPanSpaceStack: {
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "CheckLimitMFCInitRootStackSpace2", type: WIDGET.SPACE },
            ]
        },
        CheckLimitMFCInitStack2: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            hide: true,
            widgetItems: [
                { id: 'CheckLimitMFCInitStack2Icon1', type: WIDGET.ICON },
                { id: 'CheckLimitMFCInitStack2Space0', type: WIDGET.SPACE },
                { id: 'CheckLimitMFCInitStack2Text1', type: WIDGET.TEXT }
            ]
        },
        CheckLimitMFCInitStack2Text1: {
            label: 'We need PAN to get your investment details.',
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 18,
            color: ColorTokens.Grey_Charcoal,
        },
        CheckLimitMFCInitStack2Icon1: {
            name: IconTokens.VerifiedIcon1,
            size: IconSizeTokens.MD
        },
        PhoneInput: {
            onlyNumeric: true,
            value: `${phone}`,
            isFocus: false,
            regex: RegexConfig.MOBILE,
            type: InputTypeToken.MOBILE,
            state: InputStateToken.DEFAULT,
            title: "Enter mobile number",
            charLimit: 10,
            keyboardType: KeyboardTypeToken.numberPad,
            placeholder: "Enter mobile number",
            action: {
                type: ACTION.CHANGE_INPUT,
                payload: { value: "", widgetId: "PhoneInput" },
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
            },
            caption: { error: "Enter a valid mobile number" },
            errorAction: {
                type: ACTION.TOGGLE_CTA,
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
                payload: { value: false, targetWidgetId: "continue" },
            },
            successAction: {
                type: ACTION.TOGGLE_CTA,
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
                payload: { value: true, targetWidgetId: "continue" },
            },
        },
        panInputStack: {
            hide: true,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: "PanInput", type: WIDGET.INPUT }
            ]
        },
        PanInput: {
            regex: RegexConfig.PAN,
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            charLimit: 10,
            title: "Enter PAN",
            value: `${pan}`,
            placeholder: "Enter PAN",
            keyboardType: KeyboardTypeToken.default,
            isUpperCase: true,
            isFocus: false,
            caption: {
                success: "",
                error: "Enter a valid PAN.",
            },
            action: {
                type: ACTION.CHANGE_INPUT,
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
                payload: {
                    value: "",
                    widgetId: "PanInput"
                }
            },
            errorAction: {
                type: ACTION.TOGGLE_CTA,
                routeId: ROUTE.CHECK_LIMIT_MFC_INIT,
                payload: { value: false, targetWidgetId: "continue" },
            },
        },
        phoneInputStack: {
            type: StackType.column,
            hide: false,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: "PhoneInput", type: WIDGET.INPUT }
            ]
        },
        CheckLimitMFCInitStack1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: _isMobile ? StackJustifyContent.flexStart : StackJustifyContent.center,
            padding: {
                top: _isMobile ?
                    SizeTypeTokens.XS :
                    SizeTypeTokens.MD
            },
            widgetItems: [
                { id: 'CheckLimitMFCInitStackIcon1', type: WIDGET.ICON },
                { id: 'CheckLimitMFCInitStack1Space0', type: WIDGET.SPACE },
                { id: 'CheckLimitMFCInitStackT1', type: WIDGET.TEXT }
            ]
        },
        CheckLimitMFCInitStackIcon1: {
            name: IconTokens.SuccessIcon1,
            size: IconSizeTokens.MD
        },
        CheckLimitMFCInitRootStackT1: {
            label: 'Check eligibility for mutual fund portfolio',
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '600',
            lineHeight: 24,
            textAlign: _isMobile ? TextAlignTokens.left : TextAlignTokens.center,
        },
        CheckLimitMFCInitStackT1: {
            label: 'No impact on CIBIL score',
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 18,
            color: ColorTokens.Secondary_100
        },
        // tc_text: <TypographyProps> {
        //   label: 'By proceeding, I accept T&Cs, Privacy Policy and Authorize to obtain my KYC & bureau information.',
        //   fontWeight: '500',
        //   fontFamily: FontFamilyTokens.Inter,
        //   fontSize: FontSizeTokens.XS,
        //   lineHeight: 16,
        //   numberOfLines: 2
        // },
        CheckLimitMFCInitRootStackSpace0: {
            size: SizeTypeTokens.XL
        },
        CheckLimitMFCInitRootStackSpace1: {
            size: SizeTypeTokens.XL
        },
        CheckLimitMFCInitStack1Space0: {
            size: SizeTypeTokens.SM
        },
        CheckLimitMFCInitStack2Space0: {
            size: SizeTypeTokens.SM
        },
        CheckLimitMFCInitRootStackSpace2: {
            size: SizeTypeTokens.XXXL
        },
        CheckLimitMFCInitRootStackSpace3: {
            size: _isMobile ?
                SizeTypeTokens.LG :
                SizeTypeTokens.XL
        },
        CheckLimitMFCInitRootStackSpace4: {
            size: SizeTypeTokens.MD
        },
        termsAndConditionsSpace: {
            size: SizeTypeTokens.XXL
        },
        MfcentralStackSpace0: {
            size: SizeTypeTokens.SM
        },
        CheckLimitMFCInitRootStackTandCSpace0: {
            size: SizeTypeTokens.SM
        },
        CheckLimitMFCInitRootStackSpace5: {
            size: context === 'PARTNER' && _isMobile ? SizeTypeTokens.XL : context === 'PARTNER' ? SizeTypeTokens.XXXL : SizeTypeTokens.Size1
        },
    },
});
export const CheckLimitMFCInitMF = {
    onLoad: async ({ instrumentTrack, initializeAmplitude, navigateWithClear, navigate, asyncStorage, network, initializeAmplitudeWithDeviceID }, { isCheckLimitMFC }) => {
        let _isMobile = isMobile();
        const termsLink = getBuildType() === BUILD_TYPE.BORROWER_PRODUCTION ? 'https://voltmoney.in/terms/' : 'https://staging.voltmoney.in/terms/';
        const privacyLink = getBuildType() === BUILD_TYPE.BORROWER_PRODUCTION ? 'https://voltmoney.in/privacy/' : 'https://staging.voltmoney.in/privacy/';
        const lead_token = await asyncStorage.get(StoreKey.LEAD_TOKEN);
        const context = await asyncStorage.get(StoreKey.CONTEXT);
        const headers = await getAppHeader();
        headers['Authorization'] = `Bearer ${await asyncStorage.get(StoreKey.LEAD_TOKEN)}`;
        if (lead_token) {
            const verifyResponse = await network.get(`${api.getCustomerLeadsAssetDataV2}`, {
                headers: headers
            }, async () => { return; }, {
                disableDefault: true
            });
            console.log("verifyResponse: ", verifyResponse);
            if (verifyResponse?.status === 200) {
                //navigate to success page
                await sharedPropsService.setCustomerLeadAssetData(verifyResponse?.data);
                await navigateWithClear(ROUTE.CHECK_LIMIT_SUCCESS, { isCheckLimitMFC });
            }
            if (verifyResponse?.response?.status === 400) {
                if (verifyResponse?.response?.data?.voltErrorCode === 'MF_PORTFOLIO_NOT_FOUND') {
                    await navigateWithClear(ROUTE.CHECK_LIMIT_NO_MF);
                }
                else {
                    //navigate to loading screen
                    await navigateWithClear(ROUTE.CHECK_LIMIT_LOADING);
                }
            }
            if (verifyResponse?.response?.status === 401 || verifyResponse?.response?.status === 403) {
                //navigate to loading screen
                // do nothing
            }
            if (verifyResponse?.response?.status === 500) {
                await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL);
            }
        }
        if (context !== 'PARTNER' &&
            Platform.OS === 'web') {
            const params = getParametersFromURL();
            const referral_code = params?.[QUERY_PARAMS.REF];
            const amplitudeDeviceId = params?.[QUERY_PARAMS.AMPLITUDE_DEVICE_ID];
            const platform = params?.[QUERY_PARAMS.PLATFORM];
            if (platform === PLATFORM_CODE.PHONEPE) {
                _isMobile = true;
            }
            initializeAmplitude('', config.AMPLITUDE_CONFIG);
            if (amplitudeDeviceId) {
                initializeAmplitudeWithDeviceID(amplitudeDeviceId);
            }
            instrumentTrack('MFC_CHECK_LIMIT_LANDING_PAGE_VIEWED', referral_code && {
                referral_code: referral_code
            });
        }
        const initialData = await sharedPropsService.getCheckLimitInitData();
        const phone = initialData?.phoneNumber;
        const pan = initialData?.pan;
        console.log("_isMobile: 123", _isMobile);
        console.warn("VALUE IS $$$$", window.location.href);
        let isFromPhonepe;
        const url = SharedPropsService?.getURL();
        const params = getParameters(url);
        if (getPlatformName(params).includes("PHONEPE" /* AppPlatform.PHONEPE */)) {
            isFromPhonepe = true;
        }
        else {
            isFromPhonepe = false;
        }
        return Promise.resolve(template(phone, pan, context, termsLink, privacyLink, _isMobile, isFromPhonepe));
    },
    actions: {
        [ACTION.CHANGE_INPUT]: onChangeInput,
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.TOGGLE_CTA]: toggleCTA,
        [ACTION.CHECK_LIMIT]: getOTP,
        [ACTION.PRIVACY]: goToPrivacy,
        [ACTION.PRIVACY_POLICY]: goToPrivacyAction,
        [ACTION.T_AND_C]: goToTermAction,
        [ACTION.MOBILE_NUMBER_PROCEED]: mobileNumberProceed,
    },
};
